module.exports = __webpack_public_path__ + "static/media/jpmc.80c178f4.png";